import { faLayerGroup, faPlus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  SubTitle,
  Title,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { Button } from '@windmill/react-ui';

interface RegisterSolutionHeroProps {
  onRegisterSolutionIntent: () => void;
}

export const RegisterSolutionHero: React.FunctionComponent<
  RegisterSolutionHeroProps
> = ({ onRegisterSolutionIntent }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="flex flex-row justify-around items-center h-16 w-16">
        <FontAwesomeIcon className="h-12 w-12" icon={faLayerGroup} />
      </div>
      <Title>No Existing Solution Offerings</Title>
      <SubTitle className="my-5">
        Add a new solution by clicking the button below:
      </SubTitle>
      <Button onClick={onRegisterSolutionIntent} size="large">
        <FontAwesomeIcon className="pr-3 text-white" icon={faPlus} />
        Register Solution
      </Button>
    </div>
  );
};
